<section role="region" class="wrapper--carousel container" *ngIf="vm$ | async as vm">
  <div class="news-container">
    <app-wzb-carousel
      title="Actualités"
      [options]="vm.carouselOptions"
      [selectedSlideIndex]="vm.currentSlide"
      [maxSlideIndex]="vm.news?.length"
      [containerClass]="containerClass"
      (selectedSlideIndexChange)="onSlideChange($event)"
      (isClicked)="onSlideClicked($event)"
    >
      <header role="banner" class="news-container__header" data-attr="external-arrows">
        <h2 class="news-container__header__title">Actualités</h2>
        <ul class="news-container__header__buttons-holder" *ngIf="!vm.carouselOptions.arrows">
          <li>
            <button
              mat-fab
              aria-label="Bouton précédent du carousel"
              (click)="nextSplideSlide(vm.currentSlide, -vm.carouselOptions.perMove)"
              [disabled]="vm.arrowPreviousIsDisabled"
              type="button"
            >
              <mat-icon svgIcon="arrow" aria-hidden="true"></mat-icon>
            </button>
          </li>
          <li>
            <button
              mat-fab
              aria-label="Bouton suivant du carousel"
              (click)="nextSplideSlide(vm.currentSlide, vm.carouselOptions.perMove)"
              [disabled]="vm.arrowNextIsDisabled"
              type="button"
            >
              <mat-icon svgIcon="arrow" aria-hidden="true"></mat-icon>
            </button>
          </li>
        </ul>
      </header>
      <app-wzb-carousel-slide *ngFor="let news of vm.news; trackBy: trackByNewsTitle">
        <app-home-b-news-card [news]="news" class="item"></app-home-b-news-card>
      </app-wzb-carousel-slide>
    </app-wzb-carousel>
  </div>
</section>
